/* eslint react/jsx-no-bind:0*/
import _ from 'lodash';
import React, { Component } from 'react';
import { Col, FormGroup, Button } from 'react-bootstrap';
import Dialog from 'react-bootstrap-dialog'
import { Field, reduxForm, propTypes, formValueSelector, getFormSyncErrors, change } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types';
import { saveEventSetup, addMixedAgeDivision, resetWizardState, resetDivisionsOffered, deleteEventDivisionOffered, } from '../../../../redux/actions/action_event';
import { onlypositivenumbers, isEmpty } from '../../../../utils/functions';
import { blue, style, lightgray, gray, forms, videoblue, warning, red, StatusDescription } from '../../../../utils/constants';
import '../../../../utils/css/nospinner.css';
import { STEP_SEQUENCE } from '../../logic';
import { renderOptionsField } from '../../../../modules/components/fieldoptioncomponent';
import { renderCheckboxField } from '../../../../modules/components/checkboxfieldcomponent';
import MajorFractionChart from './majorfractionchart';
import SetupFields from './fields';

const sectionBorder = {
  border: `1px solid ${gray}`,
  padding: '15px',
  marginRight: '0px',
  marginBottom: '15px'
};

const formName = forms.eventinfo

class EventSetup extends Component {
  static propTypes = {
    ...propTypes
  }
  constructor(props) {
    super(props)
    this.isSetupEqual = this.isSetupEqual.bind(this);
    this.handleOnKeyPress = this.handleOnKeyPress.bind(this);
    this.saveSetup = this.saveSetup.bind(this);
    this.generateMixedAgeDivisionsOfferedSection = this.generateMixedAgeDivisionsOfferedSection.bind(this);
    this.handleAddMixedAgeDivision = this.handleAddMixedAgeDivision.bind(this);
    this.handleResetDivisionsOffered = this.handleResetDivisionsOffered.bind(this);
    this.generateUpdateErrors = this.generateUpdateErrors.bind(this);
    this.deleteDivisionOffered = this.deleteDivisionOffered.bind(this);
  }

  //#region Lifecycle methods
  //componentWillMount() {

  //}
  componentDidMount() {
    window.scrollTo(0, 0)
    this.props.dispatch(resetWizardState(STEP_SEQUENCE.Setup));
  }
  //#endregion lifecycle methods

  handleOnKeyPress(evt) {
    if (evt.which != 8 && evt.which != 0 && evt.which < 48 || evt.which > 57) {
      evt.preventDefault()
    }
  }
  handleEditField(evt) {
    evt.target.style.border = `1px solid ${videoblue}`
  }
  handleLeaveField(evt) {
    evt.target.style.border = `1px solid ${gray}`
  }
  generateUpdateErrors(eventSetupErrors) {
    const error = eventSetupErrors.map((key, index) => {
      return (<li key={index} style={{ color: warning }}>{this.props.updateSetupErrors[key]}</li>)
    })
    return error;
  }
  saveSetup() {
    const {
      eventId,
      prestinesetup,
      premierEvent,
      divisionsOffered,
      includeEnhancedAdvancerRatio,
      useMajorFraction,
      smartProviderId,
      offersScholarship,
      mixedAgeDivisionsOffered,
      advancerPolicy,
      advancerRatio
    } = this.props;


    const { isSetupEqual } = this
    const saveInfo = !isSetupEqual(prestinesetup, this.props)

    if (saveInfo) {
      const setup = {
        eventId: eventId,
        step: STEP_SEQUENCE.Setup,//4,
        premierEvent,
        divisionsOffered,
        includeEnhancedAdvancerRatio,
        useMajorFraction,
        smartProviderId,
        offersScholarship,
        mixedAgeDivisionsOffered,
        advancerPolicy,
        advancerRatio,
      }
      this.props.dispatch(saveEventSetup(eventId, setup))
    }
  }

  deleteDivisionOffered(divisionId) {
    const { dispatch, eventId, mixedAgeDivisionsOffered } = this.props;
    if (divisionId !== undefined && divisionId > 0) {
      dispatch(deleteEventDivisionOffered(eventId, divisionId));
    }
    else {
      const divisions = [...mixedAgeDivisionsOffered];
      divisions.pop();
      dispatch(change(formName, 'mixedAgeDivisionsOffered', divisions))
    }
  }

  handleRemoveDivisionOffered(Id) {
    const customBody = (
      <p>
        <i className="fa fa-exclamation-triangle text-danger" style={{ color: 'red' }} />
        &nbsp;&nbsp;
        <span>Are you sure you want to delete this division? </span>
      </p>
    )

    Dialog.setOptions({
      defaultOkLabel: 'Delete',
      defaultCancelLabel: 'Cancel',
      primaryClassName: 'btn-danger'
    })
    Dialog.Action(
      'Delete Division',
      () => this.deleteDivisionOffered(Id),
      'btn-danger'
    )
    this.dialog.show({
      body: customBody,
      title: 'Delete Division',
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => this.deleteDivisionOffered(Id))
      ],
      bsSize: 'small'
    })
  }
  isSetupEqual(/* original,current */) {
    const equal = false
    return equal
  }
  handleAddMixedAgeDivision() {
    const { dispatch } = this.props;
    dispatch(addMixedAgeDivision())
  }
  handleResetDivisionsOffered() {
    this.props.dispatch(resetDivisionsOffered());
  }

  renderField(field) {
    return (
      <div className='form-group'>
        <Col className={field.inputattrs}>
          <input
            className="form-control"
            placeholder={field.placeholder ? field.placeholder : ''}
            type={field.type ? field.type : 'text'}
            {...field.input}
            disabled={field.disabled}
            pattern={field.pattern ? field.pattern : ''}
            maxLength={field.maxLength ? field.maxLength : ''}
          />
        </Col>
      </div>);
  }
  generateMixedAgeDivisionsOfferedSection() {
    const { mixedAgeDivisionsOffered, advancerPolicy, roleName, status } = this.props;
    const ratioPolicy = advancerPolicy === '0' ? true : false;
    const yes = true;
    const isAdministrator = roleName == 'Administrator';
    // const inAddMode = mixedAgeDivisionsOffered.filter(f => f.id === 0 ).length;
    const offered = mixedAgeDivisionsOffered.map((division, index) => {
      const { divisions } = division;
      const divisionName = `mixedAgeDivisionsOffered[${index}].name`;
      const advancerRatio = `mixedAgeDivisionsOffered[${index}].advancerRatio`;
      const isNotNew = (mixedAgeDivisionsOffered[index].id > 0);
      const divisionId = mixedAgeDivisionsOffered[index].id;
      return (
        <FormGroup className='container-fluid col-sm-12' id={index} key={index + 7} style={{ paddingLeft: '10px' }}>
          <Dialog ref={(el) => { this.dialog = el }} />
          <div className="row">
            <label className="col-sm-2 col-md-2 col-lg-2 control-label">Division:</label>
            <label />
            {isNotNew &&
              <div className="col-sm-2 col-md-2 col-lg-2 "  >
                <Field
                  name={divisionName}
                  type="text"
                  label={divisionName}
                  component={this.renderField}
                  disabled={yes}
                />
              </div>
            }
            <div className='cols-sm-8 col-md-8 col-lg-8'>
              <div className="cols-sm-10">
                <div className="col-sm-5" >
                  {
                    divisions.map((madivision, indx) => {
                      const fieldDivisionName = `mixedAgeDivisionsOffered[${index}].divisions[${indx}].selected`;
                      const label = mixedAgeDivisionsOffered[index].divisions[indx].name;
                      const checked = mixedAgeDivisionsOffered[index].divisions[indx].selected;                      
                      return (
                        <Field
                          key={indx + 15}
                          inputattrs={style.inputattrs1}
                          colWidth='col-sm-1'
                          name={fieldDivisionName}
                          label={label}
                          checked={checked}
                          value={checked}
                          maxWidth='70px'
                          labelColor={blue}
                          component={renderCheckboxField}
                          disabled={isNotNew}
                        />)
                    })
                  }
                </div>
                {ratioPolicy &&
                  (
                    <div className='col-sm-2 col-md-2 col-lg-2 ' >
                      <label style={{ float: 'left', paddingTop: '7px' }}>Ratio 1:</label>
                      {/* <label>Ratio 1:</label> */}
                      <label />
                      <div className="col-sm-2 col-md-2 col-lg-2 " >
                        <Field
                          component='input'
                          type='number'
                          max="10"
                          name={advancerRatio}
                          onKeyDown={onlypositivenumbers}
                          className='no-spinners'
                          // style={{ maxWidth:'30px', maxHeight:'25px',padding:'5px', marginLeft:'5px' }}
                          style={{ maxWidth: '30px', maxHeight: '35px', padding: '5px' }}
                          placeholder='##'
                          disabled={isNotNew}
                        />
                      </div>
                    </div>
                  )
                }
                <div className='row' style={{ margin: '0 auto' }}>
                  <button type='button' className="btn btn-default" style={{ color: red, fontWeight: 800 }} onClick={() => this.handleRemoveDivisionOffered(divisionId)}
                    disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}>
                    <i className="fa fa-remove" aria-hidden="true" /> &nbsp;&nbsp;Remove
							</button>
                </div>
              </div>

            </div>

          </div>


        </FormGroup>)
    })
    return offered;
  }
  //#endregion Supporting functions
  render() {
    const graybox = gray;
    const {
      eventname,
      //advancerPolicy,
      handleSubmit,
      useMajorFraction,
      saveComponentState,
      componentStateSaved,
      currentWizardStep,
      mixedAgeDivisionsOffered,
      updateSetupErrors,
      roleName,
      status
    } = this.props;

    const isAdministrator = roleName == 'Administrator';
    const eventSetupErrors = Object.keys(updateSetupErrors);
    // const ratioPolicy = advancerPolicy === '0' ? true:false;
    //const inAddMode = mixedAgeDivisionsOffered.filter(f => f.id === 0 ).length;

    if (currentWizardStep === STEP_SEQUENCE.Setup) {
      if ((saveComponentState === true) && (componentStateSaved === false) &&  (eventSetupErrors.length == 0 )) {
        this.saveSetup();
      }
      if (componentStateSaved === true) {
        this.props.onComponentStateSaved(componentStateSaved)
      }
      if (eventSetupErrors.length > 0) {
        this.props.onComponentStateSaved(false)
      } 
    }
    return (
      <FormGroup style={{ marginTop: '1%' }} sm={12}>
        <form className="form-horizontal" onSubmit={handleSubmit} sm={12} style={{ padding: '0' }} >
          <Col sm={12} style={{ border: `1px solid ${graybox}`, padding: '10px 0 0 0', marginBottom: '10px' }}>
            <FormGroup style={{ paddingLeft: '15px', paddingBottom: '0', marginBottom: '0' }}>
              <h4 className='col-sm-12' style={{ color: blue }}>{' '}Event Name - <span style={{ color: 'green' }}>{_.startCase(_.toLower(eventname))}</span>  </h4>
            </FormGroup>
            <div style={{ border: `1px solid ${lightgray}`, marginLeft: '15px' }} className='col-sm-12' >
              <h5 className='col-sm-5' style={{ marginLeft: '0', marginBottom: '15px' }}>Divisions Offered</h5>

              {
                eventSetupErrors.length > 0 &&
                (<Col sm={12} style={sectionBorder}>
                  <h4 style={{ color: warning }}>* Please correct the following errors to proceed:</h4>
                  <ul>
                    {
                      this.generateUpdateErrors(eventSetupErrors)
                    }
                  </ul>
                </Col>)
              }
              <h5 className='col-sm-5' />
              {
                this.generateMixedAgeDivisionsOfferedSection()
              }
              <FormGroup style={{ paddingLeft: '15px', paddingBottom: '0', marginLeft: '10px' }} className='col-sm-12'>
                <Button className='btn btn-warning' disabled={(eventSetupErrors.length > 0 && mixedAgeDivisionsOffered.length > 0) || (!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled))}
                  onClick={this.handleAddMixedAgeDivision} style={{ marginLeft: '0', marginBottom: '15px', marginTop: '7px' }}>
                  <i className="fa fa-plus" />&nbsp;&nbsp;Add Division Offered</Button>
                {/* disabled={inAddMode} */}
              </FormGroup>
              <hr style={{ width: '100%' }} />
              <FormGroup style={{ paddingLeft: '15px', paddingBottom: '0', marginTop: '-7px' }}>
                <h5 className='col-sm-5' style={{ margin: '0' }}>Advancer Policies</h5>
              </FormGroup>
              {/* 	<FormGroup> */}
              <div className='col-sm-8' style={{ padding: '0' }}>
                <Field
                  inputattrs={style.inputattrs6}
                  name={SetupFields.AdvancerPolicy}
                  id={SetupFields.AdvancerPolicy}
                  values={[
                    { name: 'Champion Only', abbreviation: '1' },
                    { name: 'Advancer Ratio', abbreviation: '0' },
                  ]}
                  onChange={this.handleEventTypeChange}
                  component={renderOptionsField}
                  disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}
                />
              </div>

              <FormGroup>
                <Field
                  label={<div style={{ display: 'inline-block' }}>
                    <span>Does your event include Enhanced Advancer Ratio Policies (EARP)? </span>
                    <br />
                    <div className="text-left">
                      <span style={{ fontSize: '13.5px', fontWeight: 'bold', textDecoration: 'underline', color: 'rgb(159,96,0)' }}>
                  <span className='fa fa-info-circle' aria-hidden='true'  />&nbsp;<a href='http://usbcongress.http.internapcdn.net/usbcongress/bowl/tournaments/pdfs/usbcjuniorgoldchamp/EARP.pdf' target='blank'>
                    Click here to view the full EARP policy</a>&nbsp;</span>
                    </div>
                  </div>}
                  labelattrs={style.lblattrs6}
                  inputattrs={style.inputattr3}
                  name={SetupFields.IncludeEnhancedAdvancerRatio}
                  id={SetupFields.IncludeEnhancedAdvancerRatio}
                  values={[
                    { name: 'Yes', abbreviation: 'true' },
                    { name: 'No', abbreviation: 'false' },
                  ]}
                  onChange={this.handleEventTypeChange}
                  component={renderOptionsField}
                  disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}
                />
              </FormGroup>
              <hr />
              <FormGroup style={{ paddingLeft: '15px', paddingBottom: '0', marginTop: '-7px' }}>
                <h5 className='col-sm-5' style={{ margin: '0' }}>Premier Event</h5>
              </FormGroup>
              <FormGroup>
                <Field
                  label='Is your event a premier event?'
                  labelattrs={style.lblattrs4}
                  inputattrs={style.inputattrs4}
                  name={SetupFields.PremierEvent}
                  id={SetupFields.PremierEvent}
                  values={[
                    { name: 'Yes', abbreviation: 'true' },
                    { name: 'No', abbreviation: 'false' },
                  ]}
                  onChange={this.handleEventTypeChange}
                  component={renderOptionsField}
                  disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}
                />
              </FormGroup>
              <hr />
              <FormGroup style={{ paddingLeft: '15px', paddingBottom: '0', marginTop: '-7px' }}>
                <h5 className='col-sm-5' style={{ margin: '0' }}>Major Fraction</h5>
              </FormGroup>
              <FormGroup className='col-sm-12'>
                <Field
                  label='Is your event using major fraction?'
                  labelattrs={style.lblattrs4}
                  inputattrs={style.inputattrs4}
                  name={SetupFields.UseMajorFraction}
                  id={SetupFields.UseMajorFraction}
                  values={[
                    { name: 'Yes', abbreviation: 'true' },
                    { name: 'No', abbreviation: 'false' },
                  ]}
                  onChange={this.handleEventTypeChange}
                  component={renderOptionsField}
                  disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}
                />
              </FormGroup>
              <FormGroup>
                {
                  useMajorFraction === 'true' &&
                  (<Col sm={12} style={{ margin: '10px 15px 10px 2px' }}>
                    <MajorFractionChart />
                  </Col>)
                }
              </FormGroup>
              <hr />
              <FormGroup style={{ paddingLeft: '15px', paddingBottom: '0', marginTop: '-7px' }}>
                <h5 className='col-sm-5' style={{ margin: '0' }}>Smart</h5>
              </FormGroup>
              <FormGroup>
                <FormGroup className='col-sm-12'>
                  <Field
                    label='Is your event offering scholarship?'
                    labelattrs={style.lblattrs4}
                    inputattrs={style.inputattrs4}
                    name={SetupFields.OffersScholarship}
                    id={SetupFields.OffersScholarship}
                    values={[
                      { name: 'Yes', abbreviation: 'true' },
                      { name: 'No', abbreviation: 'false' },
                    ]}
                    onChange={this.handleEventTypeChange}
                    component={renderOptionsField}
                    disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}
                  />
                </FormGroup>
              </FormGroup>
              <FormGroup>
                <label className='col-sm-3' style={{ marginLeft: '4%' }}>Please enter your SMART Provider ID:</label>
                <Col sm={3} >
                  <Field
                    type='number'
                    name={SetupFields.SmartProviderId}
                    component='input'
                    max={999}
                    className="form-control no-spinners"
                    style={{
                      marginLeft: '-30px',
                      marginTop: '-8px'
                    }}
                    placeholder='XXXXXXXXXXXXX'
                    onKeyDown={onlypositivenumbers}
                    onChange={this.handleValueChange}
                    disabled={!isAdministrator && (status == StatusDescription.Completed || status == StatusDescription.Canceled)}
                  />
                </Col>
              </FormGroup>
            </div>
          </Col>
        </form>
      </FormGroup>)
  }
}
function mapStateToProps(state, ownProps) {
  const formName = ownProps.form
  const selector = formValueSelector(formName)
  const eventId = selector(state, 'eventId')
  const eventname = selector(state, 'eventname')
  const premierEvent = selector(state, 'premierEvent')
  const useMajorFraction = selector(state, SetupFields.UseMajorFraction)
  const offersScholarship = selector(state, SetupFields.OffersScholarship)
  const smartProviderId = selector(state, 'smartProviderId')
  const eventSeasonSettings = selector(state, 'eventSeasonSettings')
  const prestinesetup = selector(state, 'prestinesetup')
  const componentStateSaved = selector(state, 'componentStateSaved')
  const currentWizardStep = selector(state, 'currentWizardStep')
  const divisionsOffered = selector(state, 'divisionsOffered')
  const mixedAgeDivisionsOffered = selector(state, 'mixedAgeDivisionsOffered')
  const includeEnhancedAdvancerRatio = selector(state, 'includeEnhancedAdvancerRatio')
  const seasons = selector(state, 'seasons')
  const eventseason = selector(state, 'eventseason')
  const advancerPolicy = selector(state, 'advancerPolicy')
  const advancerRatio = selector(state, 'advancerRatio')
  const updateSetupErrors = getFormSyncErrors(formName)(state);
  const roleName = state.user.roleName
  const status = selector(state, 'status')
  return {
    eventId,
    eventname,
    seasons,
    eventseason,
    divisionsOffered,
    mixedAgeDivisionsOffered,
    includeEnhancedAdvancerRatio,
    useMajorFraction,
    offersScholarship,
    premierEvent,
    smartProviderId,
    eventSeasonSettings,
    advancerPolicy,
    advancerRatio,
    prestinesetup,
    componentStateSaved,
    currentWizardStep,
    updateSetupErrors,
    roleName,
    status
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    saveEventSetup,
    addMixedAgeDivision,
    resetDivisionsOffered,
    deleteEventDivisionOffered,
  }, dispatch)
}

EventSetup.propTypes = {
  handleSubmit: PropTypes.func,
  previousPage: PropTypes.func,
  dispatch: PropTypes.func,
  eventId: PropTypes.number,
  saveEventSetup: PropTypes.func,
  resetDivisionsOffered: PropTypes.func,
  addMixedAgeDivision: PropTypes.func,
  eventname: PropTypes.string,
  eventSeasonSettings: PropTypes.object,
  eventtier: PropTypes.string,
  prestinesetup: PropTypes.object,
  seasons: PropTypes.array,
  eventseason: PropTypes.string,
  divisionsOffered: PropTypes.array,
  mixedAgeDivisionsOffered: PropTypes.array,
  advancerpolicytype: PropTypes.string,
  premierEvent: PropTypes.string,
  includeEnhancedAdvancerRatio: PropTypes.string,
  useMajorFraction: PropTypes.string,
  smartProviderId: PropTypes.string,
  offersScholarship: PropTypes.string,
  advancerPolicy: PropTypes.string,
  advancerRatio: PropTypes.string,
  setHasBrackets: PropTypes.func,
  onComponentStateSaved: PropTypes.func,
  componentStateSaved: PropTypes.bool,
  saveComponentState: PropTypes.bool,
  currentWizardStep: PropTypes.number,
  updateSetupErrors: PropTypes.object,
  roleName: PropTypes.string,
  status: PropTypes.string
}

function validate(values) {
  const {
    mixedAgeDivisionsOffered,
    advancerPolicy,
    seasons
  } = values;

  const currentSeason = seasons.find(s => s.IsCurrent = 1);
  const minRatio = currentSeason.minAdvancerRatio;
  const maxRatio = currentSeason.maxAdvancerRatio;
  const advancerRatio = "0";
  const errors = {}
  let errorCounter = 0

  const unsavedParents = mixedAgeDivisionsOffered.filter(f => f.id === 0);

  if (mixedAgeDivisionsOffered.length === 0) {
    errors[errorCounter++] = 'You must enter at least one division offered';
  }    
  if (unsavedParents.length > 0) {

    const unsavedWithSelectedDivisions = (unsavedParents.map(division => division.divisions)).map((item) => (
      item.map((inneritem) => (inneritem))
    ).filter(item => item.selected === true)).filter(p => p.length > 0);

    const selectedDivisions = [].concat.apply([], unsavedWithSelectedDivisions);
    const divisionNames = selectedDivisions.map(division => division.name);
    const duplicateSelected = find_duplicate_in_array(divisionNames);

    if (duplicateSelected.length > 0) {
      errors[errorCounter++] = 'Age groups can only be added to one division ( ' + duplicateSelected + ' )';
    }
    const isMissingDivision = (unsavedParents.length != unsavedWithSelectedDivisions.length);
    if (isMissingDivision) {
      errors[errorCounter++] = 'Each division offered must have at least one selected division';
    }
    
    let isU20Mixed = false;
    let isNotU20 = false;
    const u20Enforcement = [];
    
    for (let i = 0; i < mixedAgeDivisionsOffered.length; i++) {
      const division = mixedAgeDivisionsOffered[i].divisions;
      let notU20Count = 0;
      let u20Count = 0;
      if (!isU20Mixed && !isNotU20) {
        for (let k = 0; k < division.length; k++) {
          if (division[k].selected) {
            isU20Mixed = division[k].name.toUpperCase().includes('U20');
            isNotU20 = !(division[k].name.toUpperCase().includes('U20'));
            if (isU20Mixed) {
              u20Count++;
              isU20Mixed = false;
            }
            if (isNotU20) {
              notU20Count++;
              isNotU20 = false;
            }
          }
        }
      }
      if (u20Count >= 1 && notU20Count >= 1) {
        u20Enforcement.push('1');
      }
      else {
        u20Enforcement.push('0');
      }
    }

    for (let j = 0; j < u20Enforcement.length; j++) {
      if (u20Enforcement[j] == '1') {
        errors[errorCounter++] = 'U20 division cannot be mixed with other divisions';
      }
    }
    const isMissingRatio = unsavedParents.find(up => isEmpty(up.advancerRatio));
    if (isMissingRatio) {
      errors[errorCounter++] = 'Advancer Ratio is required'
    }
    else {
      const isNotNumeric = unsavedParents.find(up => (!typeof (up.advancerRatio) == 'number'));
      if (isNotNumeric) {
        errors[errorCounter++] = 'Advancer Ratio is not numeric'
      }
      else {
        const isOutOfRange = unsavedParents.find(up => (minRatio > up.advancerRatio || maxRatio < up.advancerRatio) && (advancerPolicy == advancerRatio));
        if (isOutOfRange) {
          errors[errorCounter++] = 'Identified Advancer Ratios fall outside of the approved range of 1:' + minRatio + ' to 1:' + maxRatio
        }
      }
    }
  }
  return errors
}
function find_duplicate_in_array(arra1) {
  const object = {};
  const result = [];

  arra1.forEach(function (item) {
    if (!object[item])
      object[item] = 0;
    object[item] += 1;
  })

  for (const prop in object) {
    if (object[prop] >= 2) {
      result.push(prop);
    }
  }

  return result;

}
export default reduxForm({
  validate,
  form: formName,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false
})(connect(mapStateToProps, mapDispatchToProps)(EventSetup))


// WEBPACK FOOTER //
// ./src/containers/event/components/setup/index.js